import React from 'react';
import { Provider } from 'react-redux';
import store from '../store';
import MainRouter from './MainRouter';


// const Routes = () => (
//   <Provider store={store}>
//         <MainRouter/>
//   </Provider>
// );

// export default Routes;
export default class Routes extends React.Component {
  render() {
    return (
      <Provider store={store}>
        <MainRouter />
      </Provider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/dashboards_redux/router/Routes.jsx